module.exports = "pegasus/assets/theme3/small/7.jpg";